import { Stack, useMediaQuery } from "@mui/material";
import { LearnDropdown } from "../../Dropdown";
import { DropdownNavMenu } from "../../DrowdownNavMenu/DropdownNavMenu";
import { PricingDropdown } from "../../Dropdown/PricingDropDown";

export const DesktopNavItems = () => {
  const isDesktop = useMediaQuery("(min-width: 1200px)");
  if (!isDesktop) {
    return null;
  }
  return (
    <Stack direction="row" gap={4} marginRight={4}>
      <DropdownNavMenu />
      {/* <Link
        style={{
          textDecoration: "none",
          color: "inherit",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "nowrap",
          backgroundColor: "inherit",
        }}
        to={SCREENS.SIGNED_OUT_HOME_SCREEN}
      >
        <Text bold>About us</Text>
      </Link> */}
      <LearnDropdown />
      <PricingDropdown />
    </Stack>
  );
};
